// extracted by mini-css-extract-plugin
export default {"loader":"AuthLoader_loader__z7KUA","rotation":"AuthLoader_rotation__mYx8r"};